import axios from '../utils/index';
import { Pat, HttpResponse } from '@/typings/request';
const categoriesApi = {
    async getCustomerList(params: Pat) {
        return axios.get(`/customer/list`, { params });
    },
    async changeCustomerStatus(data: Pat) {
        return axios.put(`/customer/disable/${data.customerId}?isDisable=${data.isDisable}`, data);
    },
    async deleteCustomer(data: Pat) {
        return axios.delete(`/customer/delete/${data.customerId}`, data);
    },
    async getCustomerInfo(data: Pat) {
        return axios.get(`/customer/detail/${data.customerId}`, data);
    },
    async getCustomerTaskList(data: Pat) {
        return axios.get(
            `/task/customer/list/${data.customerId}?pageNum=${data.pageNum}&pageSize=${data.pageSize}&taskState=${data.taskState}&customerId=${data.customerId}`,
            { data }
        );
    },
    async getTaskDetail(path: string, userId: string, taskId: string) {
        return axios.get(`/task/${path}/detail/${userId}?taskId=${taskId}`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
    },
    async getCustomerRatingList(data: Pat) {
        return axios.get(
            `/core/rating/list?ratingType=${data.ratingType}&pageNum=${data.pageNum}&pageSize=${data.pageSize}&targetId=${data.targetId}`,
            {
                data,
            }
        );
    },
    async getCustomerPaymentrecordList(data: Pat) {
        return axios.get(
            `/payment-record/customer/list/${data.customerId}?taskState=${data.taskState}&pageNum=${data.pageNum}&pageSize=${data.pageSize}&customerId=${data.customerId}`,
            {
                data,
            }
        );
    },
};

export default categoriesApi;
